import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../components/home/HomePage.vue";
import LoginPage from "../components/login/LoginPage.vue";
import Events from "../components/events/EventsPage.vue";
import JoinEvent from "../components/join/JoinEventPage.vue";
import Event from "../components/events/EventPage.vue";
import EditEvent from "../components/events/manage/EditEventPage.vue";
import EditGift from "../components/gifts/manage/EditGiftPage.vue";
import store from "./store.js";

const routes = [
  {
    path: "/",
    name: "Home",
    linkActiveClass: "active-link",
    linkExactActiveClass: "exact-active-link",
    get component() {
      if (!store.getters.isAuthenticated) {
        return HomePage;
      } else {
        return Events;
      }
    },
  },
  {
    path: "/events/new",
    name: "NewEvent",
    component: EditEvent,
    meta: { requiresAuth: true },
  },
  {
    path: "/events/edit/:eventId",
    name: "EditEvent",
    component: EditEvent,
    meta: { requiresAuth: true },
  },
  {
    path: "/events/new",
    name: "NewEvent",
    component: EditEvent,
    meta: { requiresAuth: true },
  },
  {
    path: "/events/edit/:eventId",
    name: "EditEvent",
    component: EditEvent,
    meta: { requiresAuth: true },
  },
  {
    path: "/event/:eventId",
    name: "Event",
    component: Event,
    meta: { requiresAuth: true },
  },
  {
    path: "/join/:eventId/:eventName?",
    name: "JoinEvent",
    component: JoinEvent,
    meta: { requiresAuth: true },
  },
  {
    path: "/events",
    name: "Events",
    component: Events,
    meta: { requiresAuth: true },
  },
  {
    path: "/gifts/new/:eventId?",
    name: "NewGift",
    component: EditGift,
    meta: { requiresAuth: true },
  },
  {
    path: "/gifts/edit/:eventId/:giftId",
    name: "EditGift",
    component: EditGift,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
